import EfSpec from '@elem/ui/ef-spec';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('theProduct.PowerARange');
    const { locale = 'us' } = useRouter();
    return (
        <div className={styles.TheComp}>
            <EfSection
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                pad={
                    ['br', 'mx'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1742975763776/13.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1733128585697/PowerARange-pad.jpg'
                }
                h5={
                    ['br', 'mx'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1742975763679/13_M.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1733128585939/PowerARange-h5.png'
                }
                pc={
                    ['br', 'mx'].includes(locale)
                        ? 'https://websiteoss.ecoflow.com/upload/image/1742975763776/13.png'
                        : 'https://websiteoss.ecoflow.com/upload/image/1733128586112/PowerARange-pc.jpg'
                }
            />
            <EfSpec />
        </div>
    );
}
